module.exports = __webpack_public_path__ + "./img/Oferta-Cajas.00bdd145e6e84d29f5ca7c159492b88b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Oferta-Cajas.png
// module id = ./src/assets/img/Oferta-Cajas.png
// module chunks = 6